function FieldLabel({
  children,
  required = false,
  icon: Icon,
  iconSize = 14,
  sx,
  className,
  ...rest
}) {
  return (
    <div className={`field-label ${className || ''}`} style={sx} {...rest}>
      {Icon && <Icon size={iconSize} strokeWidth={2} aria-hidden="true" />}
      {children}
      {required && (
        <span className="field-label__required" aria-hidden="true">
          *
        </span>
      )}
    </div>
  )
}

export default FieldLabel
